import React from 'react'

import Link from 'shared/components/common/link'

export type BreadcrumbItem = {
  label: string
  href: string
}

type Props = {
  items: Array<BreadcrumbItem>
}

const Breadcrumbs = ({ items }: Props) => {
  const numItems = items.length

  return (
    <nav aria-label='Breadcrumb'>
      <div className='breadcrumbs'>
        <ul>
          {items.map((item, i) => {
            const isLast = i === numItems - 1
            return (
              <React.Fragment key={i}>
                {i > 0 && <li className='crumb slash'>/</li>}
                <li
                  className='crumb'
                  aria-current={isLast ? 'page' : undefined}
                >
                  {!isLast ? (
                    <Link href={item.href} sameTab>
                      {item.label}
                    </Link>
                  ) : (
                    item.label
                  )}
                </li>
              </React.Fragment>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}

export default Breadcrumbs
